/* En sus dos planillas, lo que se escribe queda centrado (Lautaro, 28/10,
 * ticket 546: «Todo lo que yo agregue que quede centrado en el excel ( ONLY
 * BITRENES Y ARRIBOS Y CORTES )»).
 *
 * Al guardar ONLY BITRENES o ARRIBOS Y CORTES, cada celda con algo escrito
 * que no tiene alineación propia pasa a centrada. Una que ya tiene la suya
 * (izquierda, derecha, centrada) no se toca: si él alineó algo a mano, queda.
 * Las otras planillas, igual que siempre. Puro. */

import { pelado } from "./torrecillas";

const PLANILLAS = ["ONLYBITRENES", "ARRIBOSYCORTES"];

export const seCentra = (nombre) => PLANILLAS.includes(pelado(nombre));

const letra = (j) => {
  let s = "";
  for (let n = j + 1; n > 0; n = Math.floor((n - 1) / 26)) s = String.fromCharCode(65 + ((n - 1) % 26)) + s;
  return s;
};

export function centrarLoEscrito(nombre, datos) {
  if (!seCentra(nombre) || !datos || !Array.isArray(datos.hojas)) return datos;
  let cambio = false;
  const hojas = datos.hojas.map((h) => {
    const celdas = Array.isArray(h?.celdas) ? h.celdas : [];
    let formato = h?.formato && typeof h.formato === "object" ? h.formato : {};
    let copia = null;
    celdas.forEach((fila, i) => {
      (Array.isArray(fila) ? fila : []).forEach((v, j) => {
        if (v === null || v === undefined || String(v).trim() === "") return;
        const ref = `${letra(j)}${i + 1}`;
        if (formato[ref]?.align) return;
        copia = copia || { ...formato };
        copia[ref] = { ...(formato[ref] || {}), align: "center" };
      });
    });
    if (!copia) return h;
    cambio = true;
    formato = copia;
    return { ...h, formato };
  });
  return cambio ? { ...datos, hojas } : datos;
}
